async function ca_analyseCart() {
  return fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      let hasVerification = false;
      let hasMissingDeclaredValue = false;

      cartData.items.forEach((item) => {
        if (item.product_type === 'card-verification') {
          hasVerification = true;
          hasMissingDeclaredValue =
            hasMissingDeclaredValue || !item.properties._declared_value || Number(item.properties._declared_value) == 0;
        }
      });

      return { hasVerification, hasMissingDeclaredValue };
    })
    .catch((error) => {
      console.error('Error fetching cart:', error);
    });
}

function ca_disableButton(id, text) {
  document.getElementById(id).disabled = true;
  document.getElementById(id).innerHTML = text;
  document.getElementById(id).style.cursor = 'not-allowed';
  document.getElementById(id).style.backgroundColor = 'grey';
}

function ca_enableButton(id, text) {
  document.getElementById(id).disabled = false;
  document.getElementById(id).innerHTML = text;
  document.getElementById(id).style.cursor = 'pointer';
  document.getElementById(id).style.backgroundColor = '#1f2937';
}
